import { mapValues } from 'es-toolkit';
import { createSelector } from '@reduxjs/toolkit';

import { getMostRecentAnalysis } from '@paragon/client-tools';

import { RootState } from '../slices';

export const getComponentDesignGuidToMostRecentAnalysisSetGuidMap = createSelector(
  (state: RootState) => state.analysisHistory,

  (analysisHistory): { readonly [componentDesignGuid: string]: string | null } =>
    mapValues(analysisHistory, (analysisHistoryForComponentDesign) =>
      analysisHistoryForComponentDesign
        ? (getMostRecentAnalysis(Object.values(analysisHistoryForComponentDesign))?.analysisSetGuid ?? null)
        : null,
    ),
);
